/**
 * Created by user on 2019/5/17.
 */

import { ITSTypeFunction } from '../generic';

export type ITSArrayListMaybeReadonly<T> = T[] | readonly T[];

export type ITSKeys = symbol | string | number;

export type ITSConstructorLike<T extends any = any> = new(...args: any) => T;

export type ITSValueOrArray<T> = T | T[];

export type ITSValueOrArrayMaybeReadonly<T> = T | ITSArrayListMaybeReadonly<T>;

export type ITSPropertyKey = string | symbol;

export type ITSAnyFunction = ITSTypeFunction<any>;

export type ITSBasicPrimitive = number | string | boolean;

export type ITSNullPrimitive = null | undefined;

